
import React from 'react';
import { DiagnosticResult } from './types';

interface ConnectionsDataSectionProps {
  results: DiagnosticResult;
}

export const ConnectionsDataSection: React.FC<ConnectionsDataSectionProps> = ({ results }) => {
  return (
    <div className="bg-muted p-4 rounded-md">
      <h3 className="font-medium mb-2">Connections Data</h3>
      <div className="text-sm space-y-1">
        <p>Total Rows: <code className="bg-background px-1 rounded">{results.connections_stats.total_rows}</code></p>
        <p>Incomplete Rows: <code className="bg-background px-1 rounded">{results.connections_stats.incomplete_rows}</code></p>
        <p>Can View Connections: <span className={results.can_view_connections ? "text-green-500" : "text-red-500"}>
          {results.can_view_connections ? "Yes" : "No"}
        </span></p>
        
        <div className="mt-2">
          <p>Unique Bases:</p>
          <pre className="bg-background p-2 rounded text-xs overflow-auto max-h-24">
            {JSON.stringify(results.connections_stats.unique_bases, null, 2)}
          </pre>
        </div>
        
        <div className="mt-2">
          <p>Unique Base IDs:</p>
          <pre className="bg-background p-2 rounded text-xs overflow-auto max-h-24">
            {JSON.stringify(results.connections_stats.unique_base_ids, null, 2)}
          </pre>
        </div>
        
        <div className="mt-2">
          <p>Assigned Bases:</p>
          <pre className="bg-background p-2 rounded text-xs overflow-auto max-h-24">
            {JSON.stringify(results.assigned_bases, null, 2)}
          </pre>
        </div>
        
        <div className="mt-2">
          <p>Assigned Base IDs:</p>
          <pre className="bg-background p-2 rounded text-xs overflow-auto max-h-24">
            {JSON.stringify(results.assigned_base_ids, null, 2)}
          </pre>
        </div>
      </div>
    </div>
  );
};
